import React from "react";
import { useStateValue } from "./../StateProvider";
import SubTotal from "../SubTotal";
import ProductCart from "../ProductCart";
import "./checkout.scss";

const CheckOut = () => {
  const [{ basket, user }] = useStateValue();

  return (
    <div className="section checkout">
      <div className="container">
        {basket.length === 0 ? (
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div>
                <h2>Your shopping cart is empty</h2>
                <h5>You have no items in basket. Buy one.</h5>
              </div>
            </div>
          </div>
        ) : (
            <div>
              <h5>
                <span style={{ color: "#ff0503" }}>Hey! </span>{" "}
                {user?.email}
              </h5>
              <h2>Items in the basket</h2>

              {basket.map((item) => (
                
                  <ProductCart
                    id={item.id}
                    title={item.title}
                    image={item.image}
                    rating={item.rating}
                    price={item.price}
                  />
                
              ))}
            

            </div>
          
        )}
        {basket.length !== 0 && <SubTotal />}
      </div>
      
    </div>
  );
};

export default CheckOut;
